<template>
	<tool-dialog
		v-bind="$props"
		:searchable="false"
		:expandable="true"
		wide
		:display-name="displayName"
		v-on="$listeners"
	>
		<div class="accordion" role="tablist">
			<!-- AssetProfile -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-profile
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Profile
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse
					id="panel-item-profile"
					visible
					accordion="building-panel"
					role="tabpanel"
				>
					<b-card-body>
						<asset-profile />
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- AssetCompany -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-company
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Companies
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse id="panel-item-company" accordion="building-panel" role="tabpanel">
					<b-card-body>
						<asset-company />
					</b-card-body>
				</b-collapse>
			</b-card>
			
			<!-- AssetDesign -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-design
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Design
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse id="panel-item-design" accordion="building-panel" role="tabpanel">
					<b-card-body>
						<asset-design />
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- AssetProgram -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-program
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Program Mix
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse id="panel-item-program" accordion="building-panel" role="tabpanel">
					<b-card-body>
						<asset-program />
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- AssetSchedule -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-schedule
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Schedule
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse id="panel-item-schedule" accordion="building-panel" role="tabpanel">
					<b-card-body>
						<asset-schedule />
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- DevelopmentFinancial -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-development-financial
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Development Financials
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse id="panel-item-development-financial" accordion="building-panel" role="tabpanel">
					<b-card-body>
						<development-financial />
					</b-card-body>
				</b-collapse>
			</b-card>

			<!-- AssetSustainability -->
			<b-card no-body class="panel-item">
				<b-card-header header-tag="header" role="tab" class="panel-item-header">
					<b-button
						v-b-toggle.panel-item-asset-sustainability
						block
						class="panel-item-header-button"
					>
						<div style="display: flex">
							<span class="panel-item-header-trigger-icon" />
							<span class="panel-item-header-title">
								Sustainability
							</span>
						</div>
					</b-button>
				</b-card-header>
				<b-collapse id="panel-item-asset-sustainability" accordion="building-panel" role="tabpanel">
					<b-card-body>
						<asset-sustainability />
					</b-card-body>
				</b-collapse>
			</b-card>
		</div>
	</tool-dialog>
</template>

<script>
import { mapState } from 'vuex';
import BaseTool from '@/components/Project/Tool/BaseTool.vue';
import AssetProfile from './AssetProfile.vue';
import AssetCompany from './AssetCompany.vue';
import AssetDesign from './AssetDesign.vue';
import AssetProgram from './AssetProgram.vue';
import AssetSchedule from './AssetSchedule.vue';
import DevelopmentFinancial from './DevelopmentFinancial.vue';
import AssetSustainability from './AssetSustainability.vue';

export default {
    name: 'AssetEditor',
	components: {AssetProfile, AssetCompany, AssetDesign, AssetProgram, AssetSchedule, DevelopmentFinancial, AssetSustainability},
	extends: BaseTool,
	props: {
	},   
    data() {
        return {
			displayDataEdit: {},
			displayName: ''
        }
    },
	computed: {
		...mapState(['elementEditorEntityDataId'])
	},
	watch: {
		elementEditorEntityDataId: {
			immediate: true,
			deep: true,
			handler() {
				this.getData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
				if (this.displayDataEdit && this.displayDataEdit.name)
					this.displayName = this.displayDataEdit.name;
			},
		}
	},
	created() {
	},
    methods: {
		async getData() {
			const assetprofileData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetprofiles`
			);
			this.displayDataEdit = assetprofileData.data;
			if (this.displayDataEdit && this.displayDataEdit.name)
				this.displayName = this.displayDataEdit.name;
		},
	}
};
</script>

<style>
.panel-item-header-title {
	position: relative;
	color: black;
	font-weight: bold;
	margin-left: 16px;
	bottom: 3px;
}
.panel-item-header {
	padding: 0px;
	border-bottom: 1px solid rgba(0,0,0,125);
}
.panel-item-header-button {
	width: 100%;
	text-align: left;
	border: none;
	background-color: #b4b4b4;
	font-size: 0.9rem !important;
}
.card-body {
	background-color: #e5e5e5;
}
.container {
	padding: 15px;
}
</style>

<style lang="scss">
.collapsed > div > .panel-item-header-trigger-icon {
	$size: 12px;
	transform: translateY($size / 4) rotate(-45deg);
}

.panel-item-header-trigger-icon {
	$size: 12px;
	width: $size;
	height: $size;
	border-right: 2px solid #363636;
	border-bottom: 2px solid #363636;
	transform: translateY($size / 4) rotate(45deg);
	transition: transform 0.2s ease;
}
</style>